<template>
    <div id="contents" class="contents conents-about">

        <div class="breadcrumb">
            <ul>
                <li><router-link :to="{name: 'Index'}">TOP</router-link></li>
                <li>About</li>
            </ul>
        </div>

        <h1 class="ttl">What is <br class="sp-only">Japan Heritage?</h1>

        <div class="mainArea">
            <div class="inner">
                <div class="videoWrapper">
                    <video-player ref="videoPlayer"
                                  mediaId="9a0d6823ecab4ebcb31040b8b4ff8f32"
                                  :options="{
                                      controls: true,
                                      preload: 'none',
                                      fluid: true,
                                      muted: false
                                  }"
                                  imagePath="About/about_mainimage"
                    ></video-player>
                </div>
            </div>
        </div>
        <div class="txtArea">
            <div class="inner">
                <p class="txt">Japan Heritage is the real Japan. The unique culture and traditions shaped by the nature, climate, and people of Japan over centuries can be found in every corner of this island nation. Japan Heritage ranges from iconic cultural properties known around the world to little-known gems far from the beaten track.</p>
                <p class="txt">Japan’s cultural heritage, both tangible and intangible, has been handed down and preserved to ensure this history and the stories it tells are shared for generations to come. Explore these sites to unlock each region’s distinct historical and cultural background, and experience the true value of Japan’s cultural properties. Come and find the real Japan. Come and find the Japan you know – and the Japan you have yet to discover.</p>
            </div>
        </div>
        <div class="gallaryArea">
            <div class="inner">
                <ul>
                    <li><span style="background-image:url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/About/about01.jpg')"></span></li>
                    <li><span style="background-image:url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/About/about02.jpg')"></span></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
    export default {
        name: "About",
        components: {VideoPlayer},
        created: function () {
            document.title = 'About | Japan Heritage Official Site'
        },
    }
</script>

<style src="./About.scss" lang="scss" scoped />
